import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController, LoadingController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { ActionSheetController } from 'ionic-angular';


/**
 * Generated class for the CancelMandatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cancel-mandate',
  templateUrl: 'cancel-mandate.html',
})
export class CancelMandatePage {
 
errorDisplay:any={};
arrResponce:any=[];
public model:any={};
   constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private fb: FormBuilder,
    private cp: CommonProvider,
    private alertController: AlertController,
    private fv : GenericFormValidationProvider,
    private loadingCtrl: LoadingController,
    public actionSheetCtrl: ActionSheetController,) {}

  ionViewDidLoad() {
   this.getCancelMandateDetailsByLoan();
  }

  getCancelMandateDetailsByLoan(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let responcePromice = this.cp.getCancelMandateByLan(loading,localStorage.getItem("cc"));
    responcePromice.then((res: any) => {
      loading.dismiss();
      console.log(JSON.parse(res),"getCancelMandateByLan");
      var res = JSON.parse(res)
      this.arrResponce = res.Payload.DetailsForAccountCancellationSr;
       

    }).catch(err => {})
  }

   presentActionSheet(objCM) {
    
        const actionSheet = this.actionSheetCtrl.create({
                                            title: 'Do you want to cancel mandate with '+objCM.BankName+' for '+objCM.BankAccount+' account number.',
                                            cssClass: 'notcomman',
                                            buttons: [
                                              {
                                                text: 'Yes',
                                                role: 'destructive',
                                                handler: () => {
                                                  this.postFormForValidation(objCM);
                                                  actionSheet.dismiss();
                                                }
                                              },{
                                                text: 'No',
                                                handler: () => {
                                                  // actionSheet.dismiss();
                                                }
                                              }
                                            ]
                                  });
              actionSheet.present();
    
  
  }
 presentActionSSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }

  postFormForValidation(objCM){
    this.errorDisplay=this.fv.checkValidationFormAllControls(document.getElementById("cancelm"),true,[]);
  
      if(this.errorDisplay.valid){
        return false;
      }else{
            let request:any={
                "ibhfl_loanaccountnumber1": localStorage.getItem("cc"),
                "customerid": JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,
                "ccs_originatingsource": "S011",
                "ccs_casecategory": "CC03",
                "ccs_casetype": "MR001",
                "ccs_casesubtype": "AS03",
                "ccs_remarks": "Mandate Cancellation SR For LAN "+localStorage.getItem("cc"),
                "ccs_casedescription": "Mandate Cancellation SR For LAN "+localStorage.getItem("cc"),
                "ibhfl_customerbankaccountno": objCM.BankAccount,
                "ibhfl_banknamestr": objCM.BankName,
                "ibhfl_micrcode": objCM.Micr
            }
             let loading = this.loadingCtrl.create({
                    content: 'Please wait...'
                  });
                  loading.present();
                  let responcePromice = this.cp.postCancelMandate(loading,request);
                  responcePromice.then((res: any) => {
                    loading.dismiss();
                    console.log(JSON.parse(res),"getCancelMandateByLan");
                    var res = JSON.parse(res)
                     
                     this.presentActionSSheet("We have received your request for mandate cancellation. please note SR no. "+res.Payload.caseid)

                  }).catch(err => {})
      }
  }

}



// WEBPACK FOOTER //
// ./src/pages/cancel-mandate/cancel-mandate.ts